import Icon from '../Icon/Icon';
import type { NotificationBannerProps } from './NotificationBanner.typed';
import * as Styled from './NotificationBanner.styled';
import { IconProps } from '../Icon/Icon.typed';

const getIconNameFromIntent = (
  intent: NotificationBannerProps['intent'],
): IconProps['name'] => {
  switch (intent) {
    case 'error':
      return 'AlertCircleOutline';
    case 'success':
      return 'CheckmarkCircleOutline';
    case 'warning':
      return 'WarningOutline';
    default:
      return 'InformationCircleOutline';
  }
};

export function NotificationBanner(props: NotificationBannerProps) {
  const {
    children,
    intent = 'default',
    icon,
    iconColor,
    askToClose,
    elevated = false,
    showIcon = true,
    size = 'm',
    ...rest
  } = props;
  const iconName = !icon ? (intent ? getIconNameFromIntent(intent) : '') : icon;
  return (
    <Styled.NotificationBanner
      elevated={elevated}
      intent={intent}
      size={size}
      {...rest}
    >
      <Styled.Body>
        {!!iconName && showIcon && (
          <Styled.Icon>
            <Icon size={size} name={iconName} color={iconColor} />
          </Styled.Icon>
        )}
        {children}
      </Styled.Body>
      {!!askToClose && (
        <Styled.Close onClick={askToClose} aria-label="close notification">
          <Icon size="xs" name="CloseOutline" />
        </Styled.Close>
      )}
    </Styled.NotificationBanner>
  );
}

export default NotificationBanner;
